
import { Session } from './types';

export const defaultSessions: Session[] = [
  {
    id: "1",
    title: "Anxiety & Stress",
    description: "Get help managing anxiety, panic attacks, and daily stress",
    color: "bg-ifind-aqua/10",
    icon: "brain",
    href: "/experts?issue=anxiety"
  },
  {
    id: "2",
    title: "Depression",
    description: "Support for feelings of sadness, hopelessness, or low mood",
    color: "bg-ifind-purple/10",
    icon: "cloud-rain",
    href: "/experts?issue=depression"
  },
  {
    id: "3",
    title: "Relationships",
    description: "Help with family conflicts, couples issues, and social challenges",
    color: "bg-ifind-teal/10",
    icon: "heart",
    href: "/experts?issue=relationships"
  },
  {
    id: "4",
    title: "Self-Esteem",
    description: "Build confidence and develop a more positive self-image",
    color: "bg-ifind-charcoal/10",
    icon: "star",
    href: "/experts?issue=self-esteem"
  },
  {
    id: "5",
    title: "Sleep Issues",
    description: "Improve your sleep quality and overcome insomnia",
    color: "bg-ifind-aqua/10",
    icon: "moon",
    href: "/experts?issue=sleep"
  },
  {
    id: "6",
    title: "Trauma & PTSD",
    description: "Process difficult experiences and find healing",
    color: "bg-ifind-purple/10",
    icon: "shield",
    href: "/experts?issue=trauma"
  },
  {
    id: "7",
    title: "Grief & Loss",
    description: "Navigate the emotions that come with significant loss",
    color: "bg-ifind-teal/10",
    icon: "heart-handshake",
    href: "/experts?issue=grief"
  },
  {
    id: "8",
    title: "Life Transitions",
    description: "Support for major changes like career shifts or relocation",
    color: "bg-ifind-charcoal/10",
    icon: "milestone",
    href: "/experts?issue=transitions"
  }
];
